export enum RoutesEnum {
  Home = "/home",
  Playcheck = "/playcheck",
  Team = "/team",
  Bets = "/bets",
  placeBet = "/place-bet",
  NotFound = "/page-not-found",
}

export enum matchStatusEnums {
  selectingOdds = "selectingOdds",
  betPlaced = "betPlaced",
  matchStarted = "matchStarted",
  matchEnded = "matchEnded",
  betClosed = "betClosed",
}

export enum minMaxWarningMessagesEnums {
  minStake = "minBetWarnMsg",
  maxStake = "maxBetWarnMsg",
  maxPayout = "maxPayoutWarnMsg",
}

export enum DrawerPositions {
  Right = "right",
  Left = "left",
  Top = "top",
  Bottom = "bottom",
}

export enum DrawerSizes {
  Xs = "xs",
  Md = "md", //with footer
  Xl = "xl",
  Lg = "lg",
  Xs2 = "xs2",
  Default = "",
}

export enum DrawerContentHeight {
  Full = "full",
  Fit = "fit",
  Screen = "screen",
}

export enum PlayerCardSize {
  Sm = "sm",
  Md = "md",
  Lg = "lg",
}

export enum PlayerCardType {
  Bronze = "bronze",
  Silver = "silver",
  Gold = "gold",
}

export enum PlayerCardVariant {
  Default = "default",
  Extended = "extended",
}

export enum TimelineDirection {
  Horizontal = "horizontal",
  Vertical = "vertical",
}

export enum TabType {
  Square = "squareButton",
  Round = "roundButton",
}

export enum PackType {
  Random = "random",
  Bronze = "bronze",
  Silver = "silver",
  Gold = "gold",
}

export enum CoinType {
  small = "smallCoins",
  Big = "bigCoins",
}

export enum PackAndCoinType {
  Pack = "pack",
  Coin = "coin",
}

export enum ChemistryColorScheme {
  ChemistryColorScheme1 = "chemistryColorScheme1",
  ChemistryColorScheme2 = "chemistryColorScheme2",
}

export enum ZIndexLevels {
  Level1 = "level1",
  Level2 = "level2",
  Level3 = "level3",
}

export enum CanvasView {
  teamView = "TEAM_VIEW",
  simulation = "SIMULATION",
  luckyDraw = "LUCKY_DRAW",
  home = "HOME",
  packOpening = "PACK_OPENING",
  teamMatching = "TEAM_MAKING",
  matchSim = "MATCH_SIMULATION",
  matchResult = "MATCH_RESULT",
  showVault = "SHOW_VAULT",
  showPromotion = "SHOW_PROMOTION",
}

export const CanvasMessage = {
  initialUserDetails: "INITIAL_USER_DETAILS",
  showTeamList: "SHOW_TEAM_LIST",
  settingClosed: "SETTINGS_CLOSED",
  leaderBoardClosed: "LEADERBOARD_CLOSED",
  leaderBoardClosed_2_0: "LEADERBOARD_CLOSED_2_0",
  boosterAdded: "BOOSTER_ADDED",
  teamData: "TEAM_DATA",
  ftuData: "FTU_DATA",
  packModalClosed: "PACK_MODAL_CLOSED",
  showFTUI: "SHOW_FTUI_PHASE2",
  showFTUIP3: "SHOW_FTUI_PHASE3",
  initiateCanvas: "INITIATE_CANVAS",
  matchId: "MATCH_ID",
  startSimulation: "START_SIMULATION",
  sendVaultData: "SEND_VAULT_DATA",
  oddsType: "ODDS_TYPE",
  showBuyPackAnimation: "SHOW_BUY_PACK_ANIMATION",
  showBuyCoinsAnimation: "SHOW_BUY_COIN_ANIMATION",
  configData: "CONFIG_DATA",
  URLS: "URLS",
  betPlaceResponse: "BET_PLACE_RESPONSE",
  isAudioOn: "IS_AUDIO_ON",
  Pop_Up_Place_Bet_Clicked: "Pop_Up_Place_Bet_Clicked",
  Pop_Up_Start_Match_Clicked: "Pop_Up_Start_Match_Clicked",
  Tutorial_Video_Playing: "Tutorial_Video_Playing",
  windowReloaded: "WINDOW_RELOADED",
  stopCanvasRendering: "STOP_CANVAS",
  resumeCanvasRendering: "RESUME_CANVAS",
};

export const CanvasEvents = {
  googleAnalyticsPageView: "GOOGLE_ANALYTICS_PAGE_VIEW",
  showDisconnection: "SHOW_DISCONNECTION",
  hideDisconnection: "HIDE_DISCONNECTION",
  isUnderMaintenance: "IS_UNDER_MAINTENANCE",
  googleAnalyticsTriggerEvent: "GOOGLE_ANALYTICS_TRIGGER_EVENT",
  hideTeamList: "HIDE_TEAM_LIST",
  showSnackBar: "SHOW_SNACKBAR",
  showPackSuccess: "SHOW_PACK_PURCHASE_SUCCESS",
  playMatch: "PLAY_MATCH",
  vaultData: "VAULT_DATA",
  allPlayers: "ALL_PLAYERS",
  showMyTeam: "SHOW_MYTEAM",
  playerSwap: "PLAYER_SWAP",
  teamEdit: "TEAM_EDIT",
  packOpeningCompleted: "PACK_ANIM_COMPLETED",
  playerDetails: "PLAYER_DETAILS",
  booster: "BOOSTERS",
  showBack: "SHOW_BACK",
  showContinue: "SHOW_CONTINUE",
  removeBack: "REMOVE_BACK",
  removeContinue: "REMOVE_CONTINUE",
  enableBack: "ENABLE_BACK",
  enableContinue: "ENABLE_CONTINUE",
  addMoreBets: "ADD_MORE_BETS",
  teamListShown: "TEAM_LIST_SHOWN",
  showVault: "SHOW_VAULT",
  ftuiComplete: "FTUI_COMPLETE",
  initData: "INIT_DATA",
  meData: "ME",
  teamData: "TEAM_DATA",
  udpateBalance: "UPDATE_BALANCE",
  showPopUp: "SHOW_POPUP",
  udpatePbfCoinBalance: "UPDATE_PBF_COIN_BALANCE",
  showSetting: "SHOW_SETTINGS",
  showBet: "SHOW_BET_PANEL",
  toggleSound: "TOGGLE_SOUND",
  showLeaderBoard: "SHOW_LEADERBOARD",
  showLeaderBoard_2_0: "SHOW_LEADERBOARD_2_0",
  currentLeagueData: "CURRENT_LEAGUE_DATA",
  myBets: "MY_BETS",
  hideReactPage: "HIDE_REACT_PAGE",
  hideReactOverLay: "HIDE_OVERLAY",
  showReactOverLay: "SHOW_OVERLAY",
  wallet: "WALLET",
  showGameRules: "SHOW_RULES",
  home: "HOME",
  teams: "TEAMS",
  reloadApp: "RELOAD_APP",
  allBadges: "ALL_BADGES",
};

export const AppEventTypes = {
  ToggleDrawerScroll: "TOGGLE_DRAWER_SCROLL",
  canvasEvent: "CANVAS_EVENT",
  toogleFooter: "TOGGLE_FOOTER",
  fetchTeam: "FETCH_TEAM",
  toggleErrorModal: "TOGGLE_ERROR_MODAL",
  toggleCanvasErrorModal: "TOGGLE_CANVAS_ERROR_MODAL",
  togglePackModal: "TOGGLE_PACK_MODAL",
  toggleWelcomeModal: "TOGGLE_WELCOME_MODAL",
  toggleVaultXpModal: "TOGGLE_VAULT_XP_MODAL",
  populateTeamEdit: "POPULATE_TEAM_EDIT",
  toggleDrawerHeight: "TOGGLE_DRAWER_HEIGHT",
  fetchCurrentBetSlip: "FETCH_CURRENT_BET_SLIP",
  togglePlaceBetOrStartMatchModal: "PLACE_BET_OR_START_MATCH_MODAL",
  handleStartMatchClickEvent: "HANDLE_START_MATCH_CLICK_EVENT",
};

export const loaderTypes = {
  default: "default",
  oddsList: "oddsList",
  placeBet: "placeBet",
  startMatch: "startMatch",
  betHistory: "betHistory",
};

export enum DrawerBgType {
  Default = "default",
  TeamEdit = "teamEdit",
  BetPannelOptions = "betPannelOptions",
  TeamName = "teamName",
  SelectNationality = "selectNatiionality",
  SummerPack = "summerPack",
}

export enum MARKET_ENUMS {
  FINAL_RESULT = "finalResult",
  UNDER_OVER = "goalsOverUnder",
  BTTS = "bothTeamsToScore",
  RESULT_BTTS = "resultBothTeamsScore",
  CORRECT_SCORE = "correctScore",
  FIRST_LAST_ANY_GOAL_SCORE = "firstLastAnytimeGoalScorer",
  HANDICAPS = "handicaps",
  FIRST_GOAL_CORRECT_SCORE = "firstGoalScorerCorrectScore",
}
